import React from "react";
import styled from "styled-components";
import constants from "./constants";

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: ${({ uiKitConfiguration }) => {
    return uiKitConfiguration.font_family || "Arial";
  }};
`;

export default Table;
